module.exports = __webpack_public_path__ + "img/home-img-01.23ce5d1b.png";